const noWhiteSpace = new RegExp(/^[^ ]+$/)
const validPassword = (password) => {
    if(!(password.length >= 8 && password.length<= 20 && noWhiteSpace.test(password))){
        return("Password must be 8 to 20 characters long, with no whitespace")
    }
}

export default validPassword;